import React from 'react';

interface SaveBarProps {
  readyCount: number;
  errorCount: number;
  emptyCount: number;
  totalFilled: number;
  showErrors: boolean;
  primaryDisabled: boolean;
  onCancel: () => void;
  onCreate: () => void;
  onSkipErrors: () => void;
}

export default function SaveBar({
  readyCount, errorCount, emptyCount, totalFilled, showErrors, primaryDisabled,
  onCancel, onCreate, onSkipErrors,
}: SaveBarProps) {
  return (
    <div className="sticky bottom-0 bg-white border-t border-line px-8 py-3.5 flex justify-between items-center gap-3 -mx-8 mt-6" style={{ boxShadow: '0 -8px 24px rgba(14,26,26,0.05)' }}>
      <div className="text-[13px] text-ink2 inline-flex items-center gap-4 flex-wrap">
        <span className="inline-flex items-center gap-1.5">
          <span className="w-[7px] h-[7px] rounded-full" style={{ background: '#0F6E56' }}></span>
          <span className="font-bold text-ink">{readyCount}</span>
          ready to create
        </span>
        {showErrors && errorCount > 0 && (
          <span className="inline-flex items-center gap-1.5" style={{ color: '#8B1538' }}>
            <span className="w-[7px] h-[7px] rounded-full" style={{ background: '#8B1538' }}></span>
            <span className="font-bold" style={{ color: '#8B1538' }}>{errorCount}</span>
            errors (fix above)
          </span>
        )}
        {emptyCount > 0 && (
          <span className="text-ink3">{emptyCount} empty rows will be skipped</span>
        )}
      </div>
      <div className="flex gap-2.5 items-center">
        <button type="button" onClick={onCancel} className="text-[13px] font-semibold text-ink3 bg-transparent border-none cursor-pointer hover:text-ink">
          Cancel
        </button>
        {showErrors && errorCount > 0 && readyCount > 0 && (
          <button
            type="button"
            onClick={onSkipErrors}
            className="h-10 px-4 rounded-lg bg-white text-ink2 text-[13px] font-semibold border border-line cursor-pointer hover:bg-panel"
          >
            Skip errors and create {readyCount}
          </button>
        )}
        <button
          type="button"
          onClick={onCreate}
          disabled={primaryDisabled}
          className="h-10 px-5 rounded-lg text-white text-[13px] font-semibold border-none"
          style={{ background: primaryDisabled ? '#96A0AB' : '#0E1A1A', cursor: primaryDisabled ? 'not-allowed' : 'pointer' }}
        >
          Create {totalFilled} accounts
        </button>
      </div>
    </div>
  );
}